import styled from "@emotion/styled";
import { Button } from "framework7-react";
import { ComponentProps } from "react";

import { useDimensionStore } from "@/stores/dimensionStore";

const Img = styled.img`
  height: 20px;
  width: 20px;
`;

type LegendToggleButtonProps = Pick<ComponentProps<typeof Img>, "src">;

export function LegendToggleButton({ src }: LegendToggleButtonProps) {
  const { toggleDimensionType } = useDimensionStore();

  return (
    <Button
      tonal
      onClick={toggleDimensionType}
    >
      <Img
        alt="Toggle feeling"
        src={src}
      />
    </Button>
  );
}
